import React from "react";

const Reviews = () => (
  <div className="container">
    <div id="ReviewsWidget" className="virtual-events-reviews" />
  </div>
);

export default Reviews;
